import React, { useState } from 'react';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { useI18n } from '../i18n/I18nProvider';

const LoginPage = ({ setToken }) => {
  const { t } = useI18n();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const contentType = response.headers.get('content-type') || '';
      const data = contentType.includes('application/json') ? await response.json() : null;
      if (!response.ok) {
        throw new Error(data?.message || (response.status >= 500
          ? 'The service is temporarily unavailable. Please try again shortly.'
          : 'Unable to reach LexiLamp. Please use ciyuantong.com and try again.'));
      }
      if (!data?.token) throw new Error('Login response was incomplete. Please try again.');
      localStorage.setItem('token', data.token);
      setToken(data.token);
      window.location.href = '/';
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 text-gray-800 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="mb-4 flex justify-end">
          <LanguageSwitcher compact />
        </div>
        <div className="text-center mb-6">
          <div className="text-3xl font-extrabold text-gray-900 tracking-tight">{t('LexiLamp')}</div>
          <div className="text-sm text-gray-500 mt-1">{t('Learn smarter. Practice better. Grow faster.')}</div>
        </div>
        <div className="bg-white/90 backdrop-blur p-8 rounded-2xl shadow-xl border border-gray-100">
          <h1 className="text-xl font-bold mb-6 text-center text-gray-800">{t('Sign In')}</h1>
          <form onSubmit={handleLogin}>
            <div className="mb-4">
              <label className="block text-gray-600 mb-2" htmlFor="username">{t('Username')}</label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full p-3 rounded-lg bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              />
            </div>
            <div className="mb-6">
              <label className="block text-gray-600 mb-2" htmlFor="password">{t('Password')}</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-3 rounded-lg bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              />
            </div>
            <button type="submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 text-white font-semibold py-3 px-4 rounded-xl transition duration-200">
              {loading ? t('Signing in…') : t('Sign In')}
            </button>
            {error && <p className="mt-4 text-red-600 text-center text-sm">{t(error)}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
